import PDL1TPSAnalysisSummary from './PDL1TPSAnalysisSummary';

export default PDL1TPSAnalysisSummary;
